import React from 'react'
import { RouteProps } from 'react-router-dom'

import SuccessTemplate from '../../../../templates/Success'

import { useCancelSuccessProps } from './useProps'

const CancelSuccess: React.FC<RouteProps> = () => {
  const templateProps = useCancelSuccessProps()

  return <SuccessTemplate {...templateProps} />
}

export default CancelSuccess
